import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const BulletCircleIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "BulletCircle",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M6.7 6.23c1.56 0 2.82 1.26 2.82 2.82s-1.26 2.82-2.82 2.82-2.82-1.26-2.82-2.82S5.14 6.23 6.7 6.23m0-1.88C4.1 4.35 2 6.46 2 9.05s2.11 4.7 4.7 4.7 4.7-2.11 4.7-4.7v-.02c0-2.59-2.1-4.69-4.69-4.69h-.02Zm0 15.77c1.56 0 2.82 1.26 2.82 2.82s-1.26 2.82-2.82 2.82-2.82-1.26-2.82-2.82a2.843 2.843 0 0 1 2.82-2.82m0-1.88c-2.6 0-4.7 2.11-4.7 4.7s2.11 4.7 4.7 4.7 4.7-2.11 4.7-4.7v-.02c0-2.59-2.1-4.69-4.69-4.69h-.02Zm22.35 1.17H14a.939.939 0 1 0 0 1.88h15.05a.939.939 0 1 0 0-1.88m-7.53 5.65h-7.53a.939.939 0 1 0 0 1.88h7.53a.939.939 0 1 0 0-1.88M14.01 7.17h15.05a.939.939 0 1 0 0-1.88H14.01a.939.939 0 1 0 0 1.88m0 5.65h7.53a.939.939 0 1 0 0-1.88h-7.53a.939.939 0 1 0 0 1.88"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.14 7.14H14.43a1.14 1.14 0 1 1 0-2.28h13.71a1.14 1.14 0 1 1 0 2.28M21.29 12.86h-6.86a1.14 1.14 0 1 1 0-2.28h6.86a1.14 1.14 0 1 1 0 2.28M28.14 22H14.43a1.14 1.14 0 1 1 0-2.28h13.71a1.14 1.14 0 1 1 0 2.28M21.29 27.71h-6.86a1.14 1.14 0 1 1 0-2.28h6.86a1.14 1.14 0 1 1 0 2.28M5.86 12.86c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4m0-5.72a1.71 1.71 0 1 0-.002 3.418A1.71 1.71 0 0 0 5.86 7.14M5.86 27.71c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4m0-5.71a1.71 1.71 0 1 0-.002 3.418A1.71 1.71 0 0 0 5.86 22"
      })
    })
  }));
};